module.exports = __webpack_public_path__ + "static/media/PayEliteBuyer.a84e25b9.png";